import { useAuthStore } from "..";
import { showErrorToast } from "../components/ToastContainer";

const useRequestActivationLink = (): (email: string) => Promise<void> => {
    const authStore = useAuthStore();

    return async (email: string): Promise<void> => {
        try {
            await authStore.requestActivationLink(email);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useRequestActivationLink;